import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { abortController } from 'store/utils';
import { projectsActions, unitsActions, paymentPlansActions, paymentPlansActionsNew, amenitiesActions, finishesActions, configurationsActions, transactionsActions, videoLinksActions, } from './actions';
const initialState = {
    project: {
        data: null,
        units: [],
    },
    data: {
        features: {
            clusters: [],
            projects: [],
        },
        list: {
            total: undefined,
            nextCursor: undefined,
        },
        projects: [],
    },
    unitTypes: [],
    unitLayouts: [],
    unitsPriceHistory: {},
    amenities: [],
    paymentPlans: [],
    paymentPlansNew: [],
    publicPaymentPlansNew: [],
    finishes: [],
    selected: null,
    socialNetworks: [],
    transactionsTable: [],
};
const store = {
    ...initialState,
    ...projectsActions,
    ...unitsActions,
    ...paymentPlansActions,
    ...paymentPlansActionsNew,
    ...amenitiesActions,
    ...finishesActions,
    ...configurationsActions,
    ...transactionsActions,
    ...videoLinksActions,
};
export default create()(devtools(immer((set, get) => abortController(store, set, get, 'Projects')), {
    name: 'Projects',
}));
